export default function componentStyleOverrides(theme) {
  const bgColor = 'white';
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: '6px',
          padding: '9px 20px 10px 20px',
        },
        outlined: {
          '&:hover': {
            backgroundColor: 'transparent',
            borderColor: theme.colors.primaryDark,
            color: theme.colors.primaryDark,
          },
          '&.Mui-disabled': {
            borderColor: 'transparent', // Custom disabled border color
            color: theme.colors.disabledText, // Custom disabled text color
          },
        },
        contained: {
          border: `1px solid ${theme.colors.secondaryDark}`,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            color: theme.colors.grey800,
            boxShadow: 'none',
          },
          '&.Mui-disabled': {
            backgroundColor: theme.colors.grey500, // Custom disabled background color
            color: 'white', // Custom disabled text color
            border: 'none', // Custom disabled border color
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        rounded: {
          borderRadius: `${theme?.customization?.borderRadius}px`,
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          color: theme.colors?.textDark,
          padding: '24px',
        },
        title: {
          fontSize: '1.125rem',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: '8px',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          paddingTop: '10px',
          paddingBottom: '10px',
          '&.Mui-selected': {
            color: theme.menuSelected,
            backgroundColor: theme.menuSelectedBack,
            '&:hover': {
              backgroundColor: theme.menuSelectedBack,
            },
            '& .MuiListItemIcon-root': {
              color: theme.menuSelected,
            },
          },
          '&:hover': {
            backgroundColor: theme.menuSelectedBack,
            color: theme.menuSelected,
            '& .MuiListItemIcon-root': {
              color: theme.menuSelected,
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          minWidth: '36px',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: theme.textDark,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        border: `1px solid ${theme.colors?.grey500}`,
        input: {
          color: theme.textDark,
          '&::placeholder': {
            color: theme.darkTextSecondary,
            fontSize: '0.875rem',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: bgColor,
          //borderColor: theme.colors?.grey500,
          borderRadius: `${theme?.customization?.borderRadius}px`,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors?.grey500,
          },
          '&:hover $notchedOutline': {
            borderColor: 'transparent',
          },
          '&.MuiInputBase-multiline': {
            padding: 1,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors?.grey500, // No border on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent', // No border when focused
          },
          '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid',
            borderColor: theme.colors?.grey500, // No border when text is entered
          },
        },
        input: {
          fontWeight: 500,
          background: bgColor,
          padding: '15.5px 14px',
          borderRadius: `${theme?.customization?.borderRadius}px`,
          '&.MuiInputBase-inputSizeSmall': {
            padding: '10px 14px',
            '&.MuiInputBase-inputAdornedStart': {
              paddingLeft: 0,
            },
          },
        },
        inputAdornedStart: {
          paddingLeft: 4,
        },
        notchedOutline: {
          borderRadius: `${theme?.customization?.borderRadius}px`,
          borderColor: theme.colors?.grey500,
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: theme.colors?.grey300,
          },
        },
        mark: {
          backgroundColor: theme.paper,
          width: '4px',
        },
        valueLabel: {
          color: theme?.colors?.primaryLight,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.divider,
          opacity: 1,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          color: theme.colors?.primaryDark,
          background: theme.colors?.primary200,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-deletable .MuiChip-deleteIcon': {
            color: 'inherit',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: theme.paper,
          background: theme.colors?.grey700,
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          fontWeight: 'bold',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.colors?.grey800,
          fontWeight: 600,
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          '&.Mui-disabled': {
            color: theme.colors?.grey600,
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: theme.colors?.grey800,
          fontWeight: 600,
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          '&.Mui-disabled': {
            color: theme.colors?.grey600,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: 'red',
          fontWeight: 400,
          fontSize: '0.75rem',
          lineHeight: '1.25rem',
        },
      },
    },
  };
}
